import { ITab } from '@framework/ui/Pages/Landing/Sections/TabsSlider/interface';
import standardizedInvestor from '@/allocate/ui/assets/standardizedInvestor.webp';
import mapsPoints from '@/allocate/ui/assets/mapsPoints.webp';
import granularPermissions from '@/allocate/ui/assets/granularPermissions.webp';
import allocateExportSecurityDetails from '@/allocate/ui/assets/allocateExportSecurityDetails.webp';
import allocateColorCoded from '@/allocate/ui/assets/allocateColorCoded.webp';
import investorTargeting from '@/allocate/ui/assets/investorTargeting.webp';
import IconDealroadshow from '@dealroadshow/uikit-icon/IconDealroadshow';
import IconPlaceOrderDocument from '@dealroadshow/uikit-icon/IconPlaceOrderDocument';
import IconFilters from '@dealroadshow/uikit-icon/IconFilters';
import IconUserLock from '@dealroadshow/uikit-icon/IconUserLock';
import IconDescription from '@dealroadshow/uikit-icon/IconDescription';

export const visualizeSection: ITab[] = [
  {
    key: 'standardizeInvestor',
    icon: IconDescription,
    title: 'Standardize your investor nomenclature data',
    description: (
      <p>
        Allocate standardizes inconsistent nomenclature for easy side-by-side comparisons
        of investor engagement across deals, sectors, time and more.
      </p>
    ),
    img: {
      src: standardizedInvestor.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Allocate standardizes your investor nomenclature upon uploading orders and allocations to the platform.',
  },
  {
    key: 'broadenAnalysis',
    icon: IconPlaceOrderDocument,
    title: 'Broaden analysis across dozens of data points',
    description: (
      <p>
        Allocate augments your pot lists with new issue pricing
        and over a dozen data points, for richer segmentation and analysis.
      </p>
    ),
    img: {
      src: mapsPoints.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Allocate maps dozens of additional data points to your pot lists for deeper insights.',
  },
  {
    key: 'applyRolePermissions',
    icon: IconUserLock,
    title: 'Apply role-based permissions',
    description: (
      <p>
        Role-based permissions ensure your pot lists are only accessible to the people and
        organizations you explicitly authorize.
      </p>
    ),
    img: {
      src: granularPermissions.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Allocate’s granular permissioning allows you to assign and update permissions for individual pot lists at any time.',
  },
];

export const allocateProprietary: ITab[] = [
  {
    key: 'exportClean',
    icon: IconPlaceOrderDocument,
    title: 'Export clean, client-ready reports',
    description: (
      <p>
        Allocate standardizes inconsistent nomenclature for
        easy side-by-side comparisons of investor engagement across deals, sectors, time and more.
      </p>
    ),
    img: {
      src: allocateExportSecurityDetails.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Allocate exports contain our clean investor names and augmented new issue security details.',
  },
  {
    key: 'runInDepth',
    icon: IconFilters,
    title: 'Run in-depth analyses across pot lists and time ',
    description: (
      <p>
        Allocate has dozens of filters and beautiful data visualizations
        for easy trend analysis across deals you’ve uploaded to our platform.
      </p>
    ),
    img: {
      src: allocateColorCoded.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Allocate’s color-coded visualizations let you see new investors and fluctuations in orders across key stages of your transaction.',
  },
  {
    key: 'superchargeInvestor',
    icon: IconDealroadshow,
    title: 'Supercharge investor outreach',
    description: (
      <p>
        Allocate empowers your Deal Roadshow marketing with real-time, data driven investor targeting lists.
      </p>
    ),
    img: {
      src: investorTargeting.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Investor Targeting continuously generates predictive investor target lists during new issue marketing on Deal Roadshow.',
  },
];
